import * as React from "react";
import InvalidateQualifierModal from "../../pages/formconfiguration/InvalidateQualifierModal";
import AddAttributeModal from "../../pages/formconfiguration/AddAttributeModal";
import { Form } from "antd";
import { SelectExistingQualifierFormProps } from "../../pages/formconfiguration/SelectExistingQualifierForm";
import AttributeSelectionForm from "../../pages/formconfiguration/AttributeSelectionForm";
import { IAttribute } from "../../../model/formconfiguration/Attribute";
import FormAttributeComponent from "../../pages/formconfiguration/FormAttributeComponent";
import { ISection } from "../../../model/formconfiguration/Section";
import { IFormConfigSectionQualifier } from "../../../model/formconfiguration/FormConfigSectionQualifier";
import { IFormConfigQualifierAttribute } from "../../../service/formconfiguration/FormConfigQualifierAttribute";
import CreateFormConfigQualifierAttributeForm, {
  CreateFormConfigQualifierAttributeFormProps
} from "../../pages/formconfiguration/CreateFormConfigQualifierAttributeForm";

export interface State {}

export interface Props {
  translate: any;
  removeQualifierModalVisible: boolean;
  hideRemoveQualifierModal: any;
  selectedFormElement?: any;
  invalidateQualifier: any;
  addAttributeModalVisible: boolean;
  formConfigSectionQualifier: IFormConfigSectionQualifier;
  hideAddAttributeModal: any;
  createFormConfigQualifierAttribute(
    parentFormConifgSectionQualifier: IFormConfigSectionQualifier,
    formConfigQualifierAttribute: IFormConfigQualifierAttribute
  ): any;
  attributes?: IAttribute[];
  onClick: any;
  invalidateAttribute: any;
  hideInvalidateAttributeModal: any;
  invalidateAttributeModalVisible: boolean;
  parentSection: ISection;
  isSelectedComponent: any;
}

export default class FormQualifierGridComponent extends React.Component<
  Props,
  State
> {
  render() {
    const {
      translate,
      removeQualifierModalVisible,
      hideRemoveQualifierModal,
      selectedFormElement,
      invalidateQualifier,
      addAttributeModalVisible,
      formConfigSectionQualifier,
      hideAddAttributeModal,
      createFormConfigQualifierAttribute,
      attributes,
      onClick,
      invalidateAttribute,
      hideInvalidateAttributeModal,
      invalidateAttributeModalVisible,
      parentSection,
      isSelectedComponent
    } = this.props;

    const CreateAttributeFormComponent = Form.create<
      CreateFormConfigQualifierAttributeFormProps
    >({})(CreateFormConfigQualifierAttributeForm);

    const AttributeSelectionFormComponent = Form.create<
      SelectExistingQualifierFormProps
    >({})(AttributeSelectionForm);

    const renderAttributes = (
      formConfigSectionQualifier: IFormConfigSectionQualifier
    ) => {
      let attributeRenderList: JSX.Element[] = [];
      if (formConfigSectionQualifier.attributes) {
        let sortedAttributes = sortAttributesByOrderNumberInsertDisplay(
          formConfigSectionQualifier.attributes
        );
        sortedAttributes.forEach(
          (formConfigQualifierAttribute: IFormConfigQualifierAttribute) => {
            attributeRenderList.push(
              <FormAttributeComponent
                key={formConfigQualifierAttribute.attribute.code}
                formConfigAttribute={formConfigQualifierAttribute}
                selectedFormElement={selectedFormElement}
                onClick={onClick}
                translate={translate}
                invalidateAttribute={invalidateAttribute}
                hideInvalidateAttributeModal={hideInvalidateAttributeModal}
                invalidateAttributeModalVisible={
                  invalidateAttributeModalVisible
                }
                maxNumber={parentSection.maxNumber}
                isSelectedComponent={isSelectedComponent}
                width={formConfigSectionQualifier.width}
              />
            );
          }
        );
      }
      return attributeRenderList;
    };

    const sortAttributesByOrderNumberInsertDisplay = (
      formConfigQualifierAttributes: IFormConfigQualifierAttribute[] = []
    ) => {
      return formConfigQualifierAttributes.sort((a, b) => {
        return a.orderNumberInsertDisplay - b.orderNumberInsertDisplay;
      });
    };

    return (
      <div>
        <InvalidateQualifierModal
          translate={translate}
          visible={
            removeQualifierModalVisible &&
            isSelectedComponent(formConfigSectionQualifier)
          }
          onCancel={hideRemoveQualifierModal}
          onOk={() => {
            if (selectedFormElement) {
              invalidateQualifier(selectedFormElement.id);
            }
            hideRemoveQualifierModal();
          }}
        />
        <AddAttributeModal
          translate={translate}
          visible={
            addAttributeModalVisible &&
            isSelectedComponent(formConfigSectionQualifier)
          }
          onCancel={() => hideAddAttributeModal()}
          CreateAttributeForm={CreateAttributeFormComponent}
          AttributeSelectionForm={AttributeSelectionFormComponent}
          createFormConfigQualifierAttribute={
            createFormConfigQualifierAttribute
          }
          parentQualifier={formConfigSectionQualifier}
          attributes={attributes}
        />
        {renderAttributes(formConfigSectionQualifier)}
      </div>
    );
  }
}
